export default __webpack_public_path__ + "static/media/icon-animais.1e6776f3.svg";